var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28286 11.2794C0.989386 11.0028 0.513578 11.0028 0.220102 11.2794C-0.0733672 11.556 -0.0733672 12.0044 0.220102 12.281L3.72624 15.5853C4.31315 16.1385 5.26482 16.1385 5.85173 15.5853L9.35995 12.2789C9.6534 12.0024 9.6534 11.5539 9.35995 11.2774C9.0665 11.0008 8.59066 11.0008 8.2972 11.2774L5.54227 13.8738V1.14085C5.54227 0.7497 5.20583 0.432617 4.79079 0.432617C4.37575 0.432617 4.03931 0.7497 4.03931 1.14085V13.8771L1.28286 11.2794Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5404 4.72058C19.8339 4.99722 20.3097 4.99722 20.6031 4.72058C20.8966 4.44402 20.8966 3.99563 20.6031 3.719L17.097 0.414663C16.5101 -0.138467 15.5584 -0.138467 14.9715 0.414663L11.4633 3.72105C11.1698 3.99761 11.1698 4.44607 11.4633 4.72263C11.7567 4.9992 12.2326 4.9992 12.526 4.72263L15.281 2.12618L15.281 14.8591C15.281 15.2503 15.6174 15.5674 16.0325 15.5674C16.4475 15.5674 16.7839 15.2503 16.7839 14.8591L16.7839 2.12285L19.5404 4.72058Z",
    fill: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveArrow);
export default __webpack_public_path__ + "static/media/inactive_arrow.c79dd286087bd07bbd37692fe17910fc.svg";
export { ForwardRef as ReactComponent };